import { Box, Link, ModuleBase, ResponsiveImage, Stack } from '@/components';
import { ExpertsListingModuleModel } from './ExpertsListingModule';
import { useTranslations } from 'next-intl';
import { animControllerInView, fadeIn } from '@/animations';

const ExpertsListingModuleGridApp = (data: ExpertsListingModuleModel) => {
  const { experts, showTypeFilter } = data.props;
  const t = useTranslations();

  return (
    <ModuleBase data={data} noPadding className="pt-6 pb-[26px] md:pt-[67px] md:pb-[65px] lg:pt-[87px] lg:pb-[75px]">
      <div className="container flex flex-wrap justify-around lg:justify-start">
        {experts &&
          experts.map((expert, index) => (
            <Stack
              key={index}
              animation={animControllerInView({ amount: 0.4 })}
              className="mb-13 flex w-[158px] md:mr-5 md:w-[260px] xl:w-[366px]"
            >
              <Box animation={fadeIn} className="relative flex w-full flex-col">
                <div className="aspect-[366/487]">
                  {expert.image && (
                    <ResponsiveImage
                      image={expert.image}
                      widths={{ xs: 158, sm: 260, md: 260, lg: 366, xl: 366 }}
                      heights={{ xs: 210, sm: 346, md: 346, lg: 487, xl: 487 }}
                    />
                  )}
                </div>
                <div className="md:bg-gray-2 flex w-full flex-grow flex-col justify-between self-end md:-mt-10 md:w-[85%] md:p-5">
                  <div className="">
                    <p className="type-item my-0 mb-2.5 h-[25px]">{showTypeFilter ? expert.type : ''}</p>
                    <h2 className="text-lg leading-6 font-light lg:text-[26px] lg:leading-8">{expert.expertName}</h2>
                    <p className="py-4 text-lg leading-[22px] font-semibold">{expert.jobTitle}</p>
                  </div>
                  {expert.landingPageLink && (
                    <div>
                      <Link
                        className="btn secondary !tracking-[normal] hover:!bg-[#f5bda2] hover:!text-black"
                        link={expert.landingPageLink}
                      >
                        {t('general.$viewMore')}
                      </Link>
                    </div>
                  )}
                </div>
              </Box>
            </Stack>
          ))}
      </div>
    </ModuleBase>
  );
};

export default ExpertsListingModuleGridApp;
